<template>
    <CardPage :section="2" :page="15" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Yes, Chile, get your life! You’ve earned another sticker for your trophy case. You’ve mastered the Icon Promo by learning about trans history and
            telling your own story! Way to go! I’m proud of you and everything you’ve accomplished.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section2/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section2/complete', true);
            this.$store.set('section2/sticker@earned', true);
        }
    }
};
</script>
